export default __webpack_public_path__ + "media/images/tenant/chooseTabas/reason_3-04b29e7974a13f806a5bd5d44b9af608.jpg";